var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
var SettingsLink = function (props) {
    var pathname = useLocation().pathname;
    var active = pathname === props.to || pathname.startsWith("".concat(props.to, "/"));
    return (_jsx(Typography, __assign({ component: RouterLink, to: props.to, sx: {
            display: 'block',
            ml: 2,
            color: 'inherit',
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline'
            },
            fontWeight: active ? 'bold' : 'normal'
        } }, { children: props.label })));
};
export default SettingsLink;
